module.exports = __webpack_public_path__ + "img/006-woman-1.0123b4bc.svg";